// here must be all pages of first level menu like /report, /contractor, /company, /setting
import { combineReducers } from 'redux';

import yesNoQuestionsAll from './yesNoQuestionsAll';
import dashboard from './dashboard';
import unofficialGrade from './unofficialGrade';

export default combineReducers({ dashboard, yesNoQuestionsAll, unofficialGrade });
